module.exports = __webpack_public_path__ + "static/media/1005.2cd27fa6.png";